import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ILocationList } from '../../../Pages/Location/ILocation';

export const GetAdsSlicer = createSlice({
  name: 'GetAds',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ILocationList>,
  reducers: {
    getAds: (state) => {
      state.isLoading = true;
    },
    successGetAds: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetAds: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getAds, successGetAds, failureGetAds } =
  GetAdsSlicer.actions;

export default GetAdsSlicer.reducer;
